import { render, staticRenderFns } from "./OpeningHour.vue?vue&type=template&id=119199e0&scoped=true"
import script from "./OpeningHour.vue?vue&type=script&lang=js"
export * from "./OpeningHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119199e0",
  null
  
)

export default component.exports